module.exports = __webpack_public_path__ + "static/media/anna.18a8aa14.png";